module.exports = __webpack_public_path__ + "static/media/studio401.a95fdc65.jpg";